/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React from 'react'
import MultiSelectPane from './MultiSelectorPane'
import { FullHeightSizer } from '../screen-util'
// import { filterMultiSelectItem } from './utils'

const ListMultiSelectPane = ({
  data,
  selectedIds,
  setSelectedIds,
  toId,
  acceptFilter,
  contentHeightOffset = 350,
  renderContent,
}) => {
  return (
    <MultiSelectPane
      selectedIds={selectedIds}
      setSelectedIds={setSelectedIds}
      data={data}
      toId={toId}
      acceptFilter={acceptFilter}
      renderContent={({ data, toggleId, selectedIds }) => (
        <FullHeightSizer heightOffset={contentHeightOffset}>
          {({ width, height }) => (
            <div
              style={{
                overflow: 'auto',
                width: `${width}px`,
                height: `${height}px`,
              }}
            >
              {renderContent({
                data,
                toggleId,
                selectedIds,
              })}
            </div>
          )}
        </FullHeightSizer>
      )}
    />
  )
}

export default ListMultiSelectPane
